import { defineMessages } from '../define';
import { plural } from '..';

/** Экран платежей и подписок. */
export const pagesObligations = defineMessages({
  ru: {
    'obligationsPage.late': 'Просрочено',
    'obligationsPage.week': 'На этой неделе',
    'obligationsPage.later': 'Позже',
    'obligationsPage.done': 'Оплачено',
    'obligationsPage.title': 'Платежи',
    'obligationsPage.newPayment': 'Новый платёж',
    'obligationsPage.emptyTitle': 'Платежей нет',
    'obligationsPage.emptyDesc': 'Аренда, связь, кредит: всё, что надо оплатить в периоде, с датой и галкой.',
    'obligationsPage.markFailed': 'Не удалось отметить',
    'obligationsPage.subscriptions': 'Подписки',
    'obligationsPage.perMonth': (p: { sum: string }) => `${p.sum} в месяц`,
    'obligationsPage.subscriptionAdd': 'Подписка',
    'obligationsPage.subscriptionsNote': 'Справочник: в итог к оплате не входят, в платежах они учтены одной строкой.',
    'obligationsPage.subsEmptyTitle': 'Подписок нет',
    'obligationsPage.subsEmptyDesc': 'VPS, музыка, облако: регулярные списания с днём месяца.',
    'obligationsPage.subFailed': 'Не удалось изменить подписку',
    'obligationsPage.leftToPay': 'Осталось оплатить',
    'obligationsPage.overdueCount': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'просрочен', few: 'просрочено', many: 'просрочено', other: 'просрочено' })}`,
    'obligationsPage.paid': 'оплачено',
    'obligationsPage.total': 'всего',
    'obligationsPage.today': 'сегодня',
    'obligationsPage.tomorrow': 'завтра',
    'obligationsPage.daysAgo': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'день', few: 'дня', many: 'дней', other: 'дня' })} назад`,
    'obligationsPage.plan': (p: { sum: string }) => `план ${p.sum}`,
    'obligationsPage.unmark': 'Снять отметку',
    'obligationsPage.mark': 'Отметить оплаченным',
    'obligationsPage.paidUntil': (p: { date: string }) => `оплачено · до ${p.date}`,
    'obligationsPage.paused': 'на паузе',
    'obligationsPage.charged': (p: { date: string }) => `списано ${p.date}`,
    'obligationsPage.willCharge': (p: { when: string }) => `спишется ${p.when}`,
    'obligationsPage.subActive': (p: { name: string }) => `Подписка «${p.name}» активна`,
  },
  en: {
    'obligationsPage.late': 'Overdue',
    'obligationsPage.week': 'This week',
    'obligationsPage.later': 'Later',
    'obligationsPage.done': 'Paid',
    'obligationsPage.title': 'Payments',
    'obligationsPage.newPayment': 'New payment',
    'obligationsPage.emptyTitle': 'No payments',
    'obligationsPage.emptyDesc': 'Rent, phone, loan: everything to pay this period, with a due date and a checkmark.',
    'obligationsPage.markFailed': 'Could not mark',
    'obligationsPage.subscriptions': 'Subscriptions',
    'obligationsPage.perMonth': (p: { sum: string }) => `${p.sum} per month`,
    'obligationsPage.subscriptionAdd': 'Subscription',
    'obligationsPage.subscriptionsNote': 'For reference: not included in the total to pay; payments count them as a single line.',
    'obligationsPage.subsEmptyTitle': 'No subscriptions',
    'obligationsPage.subsEmptyDesc': 'VPS, music, cloud: recurring charges on a day of the month.',
    'obligationsPage.subFailed': 'Could not update subscription',
    'obligationsPage.leftToPay': 'Left to pay',
    'obligationsPage.overdueCount': (p: { n: number }) => `${p.n} overdue`,
    'obligationsPage.paid': 'paid',
    'obligationsPage.total': 'total',
    'obligationsPage.today': 'today',
    'obligationsPage.tomorrow': 'tomorrow',
    'obligationsPage.daysAgo': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'day', other: 'days' })} ago`,
    'obligationsPage.plan': (p: { sum: string }) => `planned ${p.sum}`,
    'obligationsPage.unmark': 'Unmark',
    'obligationsPage.mark': 'Mark as paid',
    'obligationsPage.paidUntil': (p: { date: string }) => `paid · due ${p.date}`,
    'obligationsPage.paused': 'paused',
    'obligationsPage.charged': (p: { date: string }) => `charged ${p.date}`,
    'obligationsPage.willCharge': (p: { when: string }) => `charges ${p.when}`,
    'obligationsPage.subActive': (p: { name: string }) => `Subscription "${p.name}" active`,
  },
  be: {
    'obligationsPage.late': 'Пратэрмінавана',
    'obligationsPage.week': 'На гэтым тыдні',
    'obligationsPage.later': 'Пазней',
    'obligationsPage.done': 'Аплачана',
    'obligationsPage.title': 'Плацяжы',
    'obligationsPage.newPayment': 'Новы плацёж',
    'obligationsPage.emptyTitle': 'Плацяжоў няма',
    'obligationsPage.emptyDesc': 'Арэнда, сувязь, крэдыт: усё, што трэба аплаціць у перыядзе, з датай і птушкай.',
    'obligationsPage.markFailed': 'Не ўдалося адзначыць',
    'obligationsPage.subscriptions': 'Падпіскі',
    'obligationsPage.perMonth': (p: { sum: string }) => `${p.sum} у месяц`,
    'obligationsPage.subscriptionAdd': 'Падпіска',
    'obligationsPage.subscriptionsNote': 'Даведнік: у вынік да аплаты не ўваходзяць, у плацяжах яны ўлічаны адным радком.',
    'obligationsPage.subsEmptyTitle': 'Падпісак няма',
    'obligationsPage.subsEmptyDesc': 'VPS, музыка, воблака: рэгулярныя спісанні з днём месяца.',
    'obligationsPage.subFailed': 'Не ўдалося змяніць падпіску',
    'obligationsPage.leftToPay': 'Засталося аплаціць',
    'obligationsPage.overdueCount': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'пратэрмінаваны', few: 'пратэрмінаваныя', many: 'пратэрмінаваных', other: 'пратэрмінаванага' })}`,
    'obligationsPage.paid': 'аплачана',
    'obligationsPage.total': 'усяго',
    'obligationsPage.today': 'сёння',
    'obligationsPage.tomorrow': 'заўтра',
    'obligationsPage.daysAgo': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'дзень', few: 'дні', many: 'дзён', other: 'дня' })} таму`,
    'obligationsPage.plan': (p: { sum: string }) => `план ${p.sum}`,
    'obligationsPage.unmark': 'Зняць адзнаку',
    'obligationsPage.mark': 'Адзначыць аплачаным',
    'obligationsPage.paidUntil': (p: { date: string }) => `аплачана · да ${p.date}`,
    'obligationsPage.paused': 'на паўзе',
    'obligationsPage.charged': (p: { date: string }) => `спісана ${p.date}`,
    'obligationsPage.willCharge': (p: { when: string }) => `спішацца ${p.when}`,
    'obligationsPage.subActive': (p: { name: string }) => `Падпіска «${p.name}» актыўная`,
  },
});
